module.exports = __webpack_public_path__ + "img/logo-acompanhamentoprojetos.0bdce50b.svg";